import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetCryptoLightningReceiveLimitsRequest } from '@cash-web/shared-util-protos/squareup/cash/cryptosparky/api/deposits/public.pb'
import { GetCryptoLightningReceiveLimitsResponse } from '@cash-web/shared-util-protos/squareup/cash/cryptosparky/api/deposits/public.pb'

export const getCryptoLightningReceiveLimits = (
  request: GetCryptoLightningReceiveLimitsRequest,
  options?: CashRequestOptions
) =>
  post<GetCryptoLightningReceiveLimitsRequest, GetCryptoLightningReceiveLimitsResponse>(
    '/2.0/cash/get-crypto-lightning-receive-limits',
    request,
    { ...options, rejectOnError: true }
  )
